/**
 * Which surface a request engagement (a like or a response) came from — an
 * analytics dimension on the "Rec League Request Liked" and "Request Response
 * Created" events. It lets us attribute request engagement to the in-feed
 * request module vs. the ranked carousel vs. the standalone request page, which
 * is what the feed-module dedupe work needs to measure.
 *
 * Web threads `requestSurface` through its response composer. A future mobile
 * release should pass `requestSurface` (or the backwards-compatible `source`)
 * on like/respond requests set to one of {@link REQUEST_SURFACES}:
 *
 *   - "feed_module"  — the request card inside the feed
 *   - "carousel"     — the ranked-requests carousel
 *   - "request_page" — the standalone request detail page
 *
 * The server only records what the client sends (it can't infer the surface),
 * so missing or unrecognized values carry surface = "unknown".
 */
export const REQUEST_SURFACES = [
  "feed_module",
  "carousel",
  "request_page",
] as const;

export type RequestSurface = (typeof REQUEST_SURFACES)[number] | "unknown";

/** Coerce a client-supplied `source` into a known surface, else "unknown". */
export function normalizeRequestSurface(raw: unknown): RequestSurface {
  if (
    typeof raw === "string" &&
    (REQUEST_SURFACES as readonly string[]).includes(raw)
  ) {
    return raw as RequestSurface;
  }
  return "unknown";
}
